import { merge } from "lodash";
import type { Themes } from "@circle-react-shared/BuilderUI/Helpers/setCssVars";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";

export const flattenCssVariables = (
  variables: Themes,
  appearance: Appearance,
): Record<string, string> => {
  const { light, dark, ...rest } = variables;
  const themeColors = appearance === "light" ? light : dark;

  return merge({}, themeColors, ...Object.values(rest));
};
